module.exports = __webpack_public_path__ + "img/icon-topic-video.f3ae3307.svg";